import classNames from 'classnames';
import { getActivityStatus } from 'utils';
import { isCHFReading } from 'utils/get-reading-info';

import s from './styles.module.scss';
import CHFRenalStatus from './chf-renal-status';
import RecoveredStatus from './recovered-status';

import type { TThresholdName } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { FC } from 'react';
import type { ReadingStatus } from 'infrastructure/enums';

interface StatusProps {
  globalStatus: ReadingStatus;
  thresholdName?: TThresholdName | null;
  isRecovered?: boolean;
  wrapperClassName?: string;
}

const Status: FC<StatusProps> = ({
  globalStatus,
  thresholdName,
  isRecovered,
  wrapperClassName,
}) => {
  const status = getActivityStatus(globalStatus);
  const isCHF = isCHFReading(thresholdName);

  return (
    <div className={wrapperClassName}>
      <p
        data-cy="reading-status"
        className={classNames(s.status, s[`status-${globalStatus}`])}
      >
        {status}
      </p>
      {isRecovered && <RecoveredStatus />}
      {!isRecovered && thresholdName && isCHF && <CHFRenalStatus />}
    </div>
  );
};
export default Status;
